module.exports = __webpack_public_path__ + "static/img/oddboot_bg.cb8946a6.jpg";